<template>
  <nav
    class="
      right-nav
      fixed
      top-0
      bottom-0
      overflow-y-auto overflow-hidden
      shadow-xl
      bg-bg_color_1-100
      w-64
      z-65
      py-4
      px-6
      h-full
    "
    :class="active ? 'active' : 'inactive'"
  >
    <div class="flex justify-start">
      <a
        class="
          text-text_color_1-400
          block
          cursor-pointer
          px-4
          py-4
          border
          border-border_color_1-400
          rounded-lg
        "
        @click="$emit('close')"
      >
        <i class="fas fa-angle-double-right"></i>
      </a>
    </div>
    <div v-if="active" class="flex flex-col items-center">
      <form @submit.prevent="save">
        <h6 class="text-text_color_1-400 text-sm mt-3 mb-3 font-bold uppercase">
          {{ $t("coupons.form.label-section1") }}
        </h6>
        <div class="flex flex-wrap">
          <div class="w-full px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.name") }}
              </label>
              <input
                v-model="form.name"
                required
                type="text"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>

          <div class="w-full px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.name_en") }}
              </label>
              <input
                v-model="form.name_en"
                type="text"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>


          <div class="w-full lg:w-6/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.hospital_code") }}
              </label>
              <input
                v-model="form.hospital_code"
                type="text"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>

          <div class="w-full lg:w-6/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.department") }}
              </label>
              <select
                v-model="form.department"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              >
                <option v-for="(d, i) in departments" :key="i" :value="d.id">
                  {{ d.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.type") }}
              </label>
              <select
                v-model="form.type"
                required
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              >
                <option value="coupon">
                  {{ $t("coupons.form.select.type.coupon") }}
                </option>
                <option value="discount">
                  {{ $t("coupons.form.select.type.discount") }}
                </option>
              </select>
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.collect_method") }}
              </label>
              <select
                v-model="form.collect_method"
                required
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              >
                <option value="exclusive">
                  {{ $t("coupons.form.select.collect_method.exclusive") }}
                </option>
                <option value="special">
                  {{ $t("coupons.form.select.collect_method.special") }}
                </option>
              </select>
            </div>
          </div>

          <div class="w-full px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.url") }}
              </label>
              <input
                id="file"
                ref="file"
                type="file"
                @change="handleFileUpload"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>

          <div class="w-full px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.thumbnail_url") }}
              </label>
              <input
                id="thumbnailFile"
                ref="thumbnailFile"
                type="file"
                @change="handleThumbnailFileUpload"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>

          <div class="w-full lg:w-4/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.num_collect_limit_time") }}
              </label>
              <input
                v-model="form.num_collect_limit_time"
                required
                type="number"
                min="0"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>
          <div class="w-full lg:w-4/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.num_time") }}
              </label>
              <input
                v-model="form.num_time"
                required
                type="number"
                min="0"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>
          <div class="w-full lg:w-4/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.num_limit_time") }}
              </label>
              <input
                v-model="form.num_limit_time"
                required
                type="number"
                min="0"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>

          <div class="w-full lg:w-4/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.collect_started_at") }}
              </label>
              <datepicker
                v-model="form.collect_started_at_fmt"
                :lowerLimit="today"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>
          <div class="w-full lg:w-4/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.collect_expired_at") }}
              </label>
              <datepicker
                v-model="form.collect_expired_at_fmt"
                :lowerLimit="today"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>
          <div class="w-full lg:w-4/12 px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.expired_at") }}
              </label>
              <datepicker
                v-model="form.expired_at_fmt"
                :lowerLimit="today"
                class="
                  border-0
                  px-3
                  py-1
                  placeholder-placeholder_color_1-300
                  text-text_color_1-600
                  bg-bg_color_white
                  rounded
                  text-sm
                  shadow
                  focus:outline-none
                  focus:ring
                  w-full
                  ease-linear
                  transition-all
                  duration-150
                "
              />
            </div>
          </div>
        </div>

        <!-- Divider -->
        <hr class="mt-6 border-b-1 border-border_color_1-300" />

        <div class="flex flex-wrap">
          <div class="w-full px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.description") }}
              </label>
              <editor v-model="form.description" />
            </div>
          </div>
        </div>

        <!-- Divider -->
        <hr class="mt-6 border-b-1 border-border_color_1-300" />

        <div class="flex flex-wrap">
          <div class="w-full px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.description_en") }}
              </label>
              <editor v-model="form.description_en" />
            </div>
          </div>
        </div>

        <!-- Divider -->
        <hr class="mt-6 border-b-1 border-border_color_1-300" />

        <div class="flex flex-wrap">
          <div class="w-full px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.condition") }}
              </label>
              <editor v-model="form.condition" />
            </div>
          </div>
        </div>

        <!-- Divider -->
        <hr class="mt-6 border-b-1 border-border_color_1-300" />

        <div class="flex flex-wrap">
          <div class="w-full px-4 pt-2">
            <div class="relative w-full">
              <label
                class="
                  block
                  uppercase
                  text-text_color_1-600
                  text-xs
                  font-bold
                  mb-2
                "
              >
                {{ $t("coupons.form.condition_en") }}
              </label>
              <editor v-model="form.condition_en" />
            </div>
          </div>
        </div>

        <div class="flex flex-wrap mt-20">
          <button
            class="
              bg-btn_green_color_active-500
              text-text_color_white
              active:bg-btn_green_color_active-600
              font-bold
              uppercase
              text-xs
              px-4
              py-2
              rounded
              shadow
              hover:shadow-md
              outline-none
              focus:outline-none
              mr-1
              ease-linear
              transition-all
              duration-150
            "
            type="submit"
          >
            <i class="fas fa-save"></i> {{ $t("app.button.save") }}
          </button>
          <button
            v-if="model"
            class="
              bg-btn_gray_color_active-50
              text-text_color_1-600
              active:bg-btn_gray_color_active-200
              uppercase
              text-xs
              px-4
              py-2
              rounded
              shadow
              hover:shadow-md
              outline-none
              focus:outline-none
              mr-1
              ease-linear
              transition-all
              duration-150
            "
            @click.prevent="reset"
          >
            <i class="fas fa-undo-alt"></i> {{ $t("app.button.reset") }}
          </button>
        </div>
      </form>
    </div>
  </nav>
</template>
); }

<script>
import Editor from "@/components/Common/Editor.vue";
import Datepicker from "vue3-datepicker";

export default {
  data() {
    return {
      form: {},
      today: new Date(),
      file: "",
      thumbnailFile: "",
    };
  },
  emits: ["close", "onSubmitUpdate", "onSubmitCreate"],
  components: {
    Editor,
    Datepicker,
  },
  props: {
    active: {
      default: false,
    },
    model: {
      default: null,
    },
    departments: {
      default: [],
    },
  },
  methods: {
    save() {
      this.form.name_en = this.form.name_en || this.form.name;
      this.form.description_en = this.form.description_en || this.form.description;
      this.form.condition_en = this.form.condition_en || this.form.condition;
      if (this.model) {
        this.$emit("onSubmitUpdate", {
          ...this.form,
          file: this.file,
          thumbnailFile: this.thumbnailFile,
          expired_at: this.$moment(this.form.expired_at_fmt)
            .set("hour", 23)
            .set("minute", 59)
            .set("second", 59)
            .format(),
          collect_expired_at: this.$moment(this.form.collect_expired_at_fmt)
            .set("hour", 23)
            .set("minute", 59)
            .set("second", 59)
            .format(),
          collect_started_at: this.$moment(this.form.collect_started_at_fmt)
            .set("hour", 0)
            .set("minute", 0)
            .set("second", 0)
            .format(),
        });
      } else {
        this.$emit("onSubmitCreate", {
          ...this.form,
          file: this.file,
          thumbnailFile: this.thumbnailFile,
          expired_at: this.$moment(this.form.expired_at_fmt)
            .set("hour", 23)
            .set("minute", 59)
            .set("second", 59)
            .format(),
          collect_expired_at: this.$moment(this.form.collect_expired_at_fmt)
            .set("hour", 23)
            .set("minute", 59)
            .set("second", 59)
            .format(),
          collect_started_at: this.$moment(this.form.collect_started_at_fmt)
            .set("hour", 0)
            .set("minute", 0)
            .set("second", 0)
            .format(),
        });
      }
      if (this.model) {
        this.form = {
          ...this.model,
          expired_at_fmt: new Date(this.model.expired_at || this.today),
          collect_expired_at_fmt: new Date(
            this.model.collect_expired_at || this.today
          ),
          collect_started_at_fmt: new Date(
            this.model.collect_started_at || this.today
          ),
        };
        this.file = "";
        this.thumbnailFile = "";
      } else {
        this.form = {};
        this.file = "";
        this.thumbnailFile = "";
      }
      this.$emit("close");
    },
    reset() {
      let confirmed = window.confirm(`${this.$t("app.confirm-reset")}`);
      if (confirmed) {
        if (this.model) {
          this.form = {
            ...this.model,
            expired_at_fmt: new Date(this.model.expired_at || this.today),
            collect_expired_at_fmt: new Date(
              this.model.collect_expired_at || this.today
            ),
            collect_started_at_fmt: new Date(
              this.model.collect_started_at || this.today
            ),
          };
          this.file = "";
          this.thumbnailFile = "";
        } else {
          this.form = {};
          this.file = "";
          this.thumbnailFile = "";
        }
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    handleThumbnailFileUpload() {
      this.thumbnailFile = this.$refs.thumbnailFile.files[0];
    },
  },
  watch: {
    model(val) {
      if (val) {
        this.form =
          {
            ...val,
            expired_at_fmt: new Date(val.expired_at || this.today),
            collect_expired_at_fmt: new Date(
              val.collect_expired_at || this.today
            ),
            collect_started_at_fmt: new Date(
              val.collect_started_at || this.today
            ),
          } || {};
        this.file = "";
        this.thumbnailFile = "";
      } else {
        this.form = {};
        this.file = "";
        this.thumbnailFile = "";
      }
    },
  },
};
</script>

<style scoped>
.right-nav {
  left: auto;
  right: 0;
  width: 70%;
  max-width: 70%;
}

@media (max-width: 768px) {
  .right-nav {
    left: auto;
    right: 0;
    width: 100%;
    max-width: 100%;
  }
}

.active {
  transform: translatex(0);
  transition: all 0.2s ease-out;
}

.inactive {
  transform: translatex(100%);
  transition: all 0.2s ease-out;
}
</style>